module.exports = __webpack_public_path__ + "img/jiahao.c237a968.png";